/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConflictResolution } from './ConflictResolution';
import {
    ConflictResolutionFromJSON,
    ConflictResolutionFromJSONTyped,
    ConflictResolutionToJSON,
    ConflictResolutionToJSONTyped,
} from './ConflictResolution';

/**
 * 
 * @export
 * @interface ImportConfigurationRequestDto
 */
export interface ImportConfigurationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ImportConfigurationRequestDto
     */
    defaultDateFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportConfigurationRequestDto
     */
    numberFormat?: string | null;
    /**
     * 
     * @type {ConflictResolution}
     * @memberof ImportConfigurationRequestDto
     */
    conflictResolution?: ConflictResolution;
    /**
     * 
     * @type {boolean}
     * @memberof ImportConfigurationRequestDto
     */
    detectDuplicates?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ImportConfigurationRequestDto
     */
    batchSize?: number;
}



/**
 * Check if a given object implements the ImportConfigurationRequestDto interface.
 */
export function instanceOfImportConfigurationRequestDto(value: object): value is ImportConfigurationRequestDto {
    return true;
}

export function ImportConfigurationRequestDtoFromJSON(json: any): ImportConfigurationRequestDto {
    return ImportConfigurationRequestDtoFromJSONTyped(json, false);
}

export function ImportConfigurationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportConfigurationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'defaultDateFormat': json['defaultDateFormat'] == null ? undefined : json['defaultDateFormat'],
        'numberFormat': json['numberFormat'] == null ? undefined : json['numberFormat'],
        'conflictResolution': json['conflictResolution'] == null ? undefined : ConflictResolutionFromJSON(json['conflictResolution']),
        'detectDuplicates': json['detectDuplicates'] == null ? undefined : json['detectDuplicates'],
        'batchSize': json['batchSize'] == null ? undefined : json['batchSize'],
    };
}

export function ImportConfigurationRequestDtoToJSON(json: any): ImportConfigurationRequestDto {
    return ImportConfigurationRequestDtoToJSONTyped(json, false);
}

export function ImportConfigurationRequestDtoToJSONTyped(value?: ImportConfigurationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'defaultDateFormat': value['defaultDateFormat'],
        'numberFormat': value['numberFormat'],
        'conflictResolution': ConflictResolutionToJSON(value['conflictResolution']),
        'detectDuplicates': value['detectDuplicates'],
        'batchSize': value['batchSize'],
    };
}

